import React from 'react';
import styles from './DriDashboard.style';
import Module from '../../components/Module';

const DriHome = () => {
  return (
    <>
      <Module>
        <iframe
          sandbox
          className={styles.iframe_embed}
          src={window.config.powerBIDriDashboard}
          title="Dashboard PowerBI"
        />
      </Module>
    </>
  );
};

export default DriHome;
